export const Alert = {
  baseStyle: {
    container: {
      rounded: "md",
    },
  },
};
